module.exports = __webpack_public_path__ + "img/T6-B-xh_5.8b6fd746.png";